import { render, staticRenderFns } from "./NotificationsSettings.vue?vue&type=template&id=4331dbab&scoped=true&"
import script from "./NotificationsSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationsSettings.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSettings.vue?vue&type=style&index=0&id=4331dbab&lang=css&"
import style1 from "./NotificationsSettings.vue?vue&type=style&index=1&id=4331dbab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4331dbab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4331dbab')) {
      api.createRecord('4331dbab', component.options)
    } else {
      api.reload('4331dbab', component.options)
    }
    module.hot.accept("./NotificationsSettings.vue?vue&type=template&id=4331dbab&scoped=true&", function () {
      api.rerender('4331dbab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NotificationsSettings.vue"
export default component.exports